import { Box, InformationCircleSolid, Tooltip } from '@bonusly/design-system';

export const TableHeaderTooltip = ({ label }: { label: string }) => {
	return (
		<Box as="span" whiteSpace="nowrap" className="info-tooltip" width={0}>
			{'\u00A0'}
			<Tooltip label={label} placement="top" hasArrow openDelay={500} zIndex={100}>
				<Box
					as="span"
					display="inline-block"
					h={4}
					verticalAlign="middle"
					whiteSpace="nowrap"
					transition="opacity 0.2s ease"
					onClick={(e: React.MouseEvent) => e.stopPropagation()}
					data-testid="info-tooltip"
				>
					<InformationCircleSolid size="xs" color="text.softest" _hover={{ color: 'gray.700' }} />
				</Box>
			</Tooltip>
		</Box>
	);
};
